module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasOrganization) ? _c('div', {
    staticClass: "organization-wrapper detail-wrapper full-height scroll-y border-top"
  }, [_c('div', {
    staticClass: "panel panel-heading m-b-0 m-t-0 p-t-0"
  }, [_c('div', {
    staticClass: "btn-link",
    on: {
      "click": function($event) {
        _vm.$refs.importInput.click()
      }
    }
  }, [_c('i', {
    staticClass: "pg-sent"
  }), _vm._v("IMPORT")]), _vm._v(" "), _c('div', {
    staticClass: "btn-link",
    on: {
      "click": _vm.exportData
    }
  }, [_c('i', {
    staticClass: "pg-download"
  }), _vm._v("EXPORT CORE")]), _vm._v(" "), _c('div', {
    staticClass: "btn-link",
    on: {
      "click": _vm.exportGeoData
    }
  }, [_c('i', {
    staticClass: "pg-download"
  }), _vm._v("EXPORT GEOJSON")]), _vm._v(" "), _c('div', {
    staticClass: "btn-link text-danger",
    on: {
      "click": _vm.resetPassword
    }
  }, [_c('i', {
    staticClass: "pg-refresh"
  }), _vm._v("RESET PASSWORD")]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('h1', [_c('strong', [_vm._v(_vm._s(_vm.organization.company))]), _vm._v(" / " + _vm._s(_vm.organization.name))])]), _vm._v(" "), _c('div', {
    staticClass: "import-form hide"
  }, [_c('form', {
    ref: "importForm",
    attrs: {
      "enctype": "multipart/form-data",
      "onSubmit.preventDefault": "importData",
      "novalidate": ""
    }
  }, [_c('input', {
    ref: "importInput",
    attrs: {
      "type": "file",
      "accept": "application/json"
    },
    on: {
      "change": _vm.onImport
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "panel m-t-0 p-t-0 p-l-20"
  }, [_c('ul', {
    staticClass: "nav nav-tabs nav-tabs-simple"
  }, [_vm._m(1, false, false), _vm._v(" "), (false) ? _c('li', [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": "#tab-invoicing"
    }
  }, [_vm._v("Invoicing")])]) : _vm._e(), _vm._v(" "), _vm._m(2, false, false), _vm._v(" "), (_vm.isAdmin()) ? _c('li', [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": "#tab-data"
    }
  }, [_vm._v("Data")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "tab-overview"
    }
  }, [_c('div', {
    staticClass: "row p-b-20"
  }, [_c('div', {
    staticClass: "col-lg-3 col-md-3"
  }, [_c('h4', {
    class: {
      'bold no-margin': true,
      'text-success': _vm.organization.plan === 'free',
        'text-primary': _vm.organization.plan === 'guru' && !_vm.isExpired(_vm.organization),
        'text-warning': _vm.isExpired(_vm.organization),
    }
  }, [_vm._v(_vm._s(_vm.organization.plan) + " "), (_vm.isExpired(_vm.organization)) ? _vm._t("default", [_vm._v("(expired)")]) : _vm._e()], 2), _vm._v(" "), _vm._m(3, false, false), _vm._v(" "), _vm._m(4, false, false)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3"
  }, [_c('h5', {
    staticClass: "bold no-margin p-t-5"
  }, [_c('date-picker', {
    ref: "expirePicker",
    attrs: {
      "first-day-of-week": 1,
      "type": "datetime",
      "format": "dd.MM.yyyy HH:mm",
      "confirm": true,
      "lang": "en",
      "width": "100%",
      "not-before": new Date(),
      "confirm-text": "Confirm"
    },
    on: {
      "confirm": _vm.setExpirationDate
    },
    model: {
      value: (_vm.expirationDate),
      callback: function($$v) {
        _vm.expirationDate = $$v
      },
      expression: "expirationDate"
    }
  })], 1), _vm._v(" "), _vm._m(5, false, false), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3"
  }, [_c('h5', {
    staticClass: "bold no-margin p-t-5"
  }, [_vm._v(_vm._s(_vm.$format.date(_vm.organization.createdAt)))]), _vm._v(" "), _c('p', {
    staticClass: "small no-margin"
  }, [_vm._v("Registered since")])]), _vm._v(" "), _vm._m(6, false, false)]), _vm._v(" "), _c('div', {
    staticClass: "row column-seperation border-top"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h3', {
    staticClass: "semi-bold text-center"
  }, [_vm._v("Registration")]), _vm._v(" "), _c('table', {
    staticClass: "table no-padding no-margin small-table"
  }, [_c('tr', [_c('th', {
    staticClass: "col-lg-6 no-margin"
  }, [_vm._v("Company")]), _vm._v(" "), _c('td', {
    staticClass: "col-lg-6 no-margin"
  }, [_vm._v(_vm._s(_vm.organization.company))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "col-lg-6 no-margin"
  }, [_vm._v("User")]), _vm._v(" "), _c('td', {
    staticClass: "col-lg-6 no-margin"
  }, [_vm._v(_vm._s(_vm.organization.name))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "col-lg-6 no-margin"
  }, [_vm._v("Email")]), _vm._v(" "), _c('td', {
    staticClass: "col-lg-6 no-margin"
  }, [_c('a', {
    attrs: {
      "href": ("mailto:" + (_vm.organization.mail))
    }
  }, [_vm._v(_vm._s(_vm.organization.email))])])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "col-lg-6 no-margin"
  }, [_vm._v("Country")]), _vm._v(" "), _c('td', {
    staticClass: "col-lg-6 no-margin"
  }, [_vm._v(_vm._s(_vm.organization.country))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "col-lg-6 no-margin"
  }, [_vm._v("Background")]), _vm._v(" "), _c('td', {
    staticClass: "col-lg-6 no-margin"
  }, [_vm._v(_vm._s(_vm.organization.background))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "col-lg-6 no-margin"
  }, [_vm._v("Contact Us")]), _vm._v(" "), _c('td', {
    staticClass: "col-lg-6 no-margin"
  }, [_vm._v(_vm._s(_vm.organization.contact_us ? 'YES' : 'NO'))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "col-lg-6 no-margin"
  }, [_vm._v("Registered At")]), _vm._v(" "), _c('td', {
    staticClass: "col-lg-6 no-margin"
  }, [_vm._v(_vm._s(_vm.$format.date(_vm.organization.createdAt)))])]), _vm._v(" "), (_vm.isAdmin()) ? _c('tr', [_c('th', {
    staticClass: "col-lg-6 no-margin"
  }, [_vm._v("Access Token")]), _vm._v(" "), _c('td', {
    staticClass: "col-lg-6 no-margin"
  }, [_c('div', {
    staticClass: "token-wrapper"
  }, [(!_vm.showToken) ? _c('span', {
    staticClass: "pointer text-success bold",
    on: {
      "click": function($event) {
        _vm.showToken = true
      }
    }
  }, [_vm._v("show token")]) : _vm._e(), _vm._v(" "), (_vm.showToken) ? _c('span', [_vm._v(_vm._s(_vm.organization.tokens[0]))]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.isAdmin()) ? _c('tr', [_c('th', {
    staticClass: "col-lg-6 no-margin"
  }, [_vm._v("ID")]), _vm._v(" "), _c('td', {
    staticClass: "col-lg-6 no-margin"
  }, [_vm._v(_vm._s(_vm.organization.id))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h3', {
    staticClass: "semi-bold text-center"
  }, [_vm._v("Usage Overview")]), _vm._v(" "), _c('table', {
    staticClass: "table small-table"
  }, [_c('tr', [_c('th', {
    staticClass: "col-lg-6 no-margin"
  }, [_vm._v("Places")]), _vm._v(" "), _c('td', {
    class: {
      'col-lg-6 no-margin bold': true,
      'text-success': this.data.places.length > 0,
        'text-danger': this.data.places.length === 0
    }
  }, [_vm._v("\n                  " + _vm._s(this.data.places.length))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "col-lg-6 no-margin"
  }, [_vm._v("Floors")]), _vm._v(" "), _c('td', {
    class: {
      'col-lg-6 no-margin bold': true,
      'text-success': this.data.floors.length > 0,
        'text-danger': this.data.floors.length === 0
    }
  }, [_vm._v(_vm._s(this.data.floors.length))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "col-lg-6 no-margin"
  }, [_vm._v("Departments")]), _vm._v(" "), _c('td', {
    class: {
      'col-lg-6 no-margin bold': true,
      'text-success': this.data.departments.length > 0,
        'text-danger': this.data.departments.length === 0
    }
  }, [_vm._v(_vm._s(this.data.departments.length))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "col-lg-6 no-margin"
  }, [_vm._v("Geofences")]), _vm._v(" "), _c('td', {
    class: {
      'col-lg-6 no-margin bold': true,
      'text-success': this.data.geofences.length > 0,
        'text-danger': this.data.geofences.length === 0
    }
  }, [_vm._v(_vm._s(this.data.geofences.length))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "col-lg-6 no-margin"
  }, [_vm._v("Inputs")]), _vm._v(" "), _c('td', {
    class: {
      'col-lg-6 no-margin bold': true,
      'text-success': this.data.inputs.length > 0,
        'text-danger': this.data.inputs.length === 0
    }
  }, [_vm._v(_vm._s(this.data.inputs.length))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "col-lg-6 no-margin"
  }, [_vm._v("Node-RED Flows")]), _vm._v(" "), _c('td', {
    class: {
      'col-lg-6 no-margin bold': true,
      'text-success': this.data.red_flows.length > 0,
        'text-danger': this.data.red_flows.length === 0
    }
  }, [_vm._v(_vm._s(this.data.red_flows.length))])]), _vm._v(" "), (false) ? _vm._t("default", [_vm._m(7, false, false), _vm._v(" "), _vm._m(8, false, false), _vm._v(" "), _vm._m(9, false, false), _vm._v(" "), _vm._m(10, false, false), _vm._v(" "), _vm._m(11, false, false), _vm._v(" "), _vm._m(12, false, false)]) : _vm._e()], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "tab-geodata"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2 bold"
  }, [_vm._v("POIs")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 h-40"
  }, [_vm._v(_vm._s(_vm.geodata.filter(function (f) { return f.properties.usecase === 'poi'; }).length))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 h-40"
  }, [_c('div', {
    staticClass: "btn btn-xs",
    on: {
      "click": function($event) {
        _vm.exportGeoItems('pois', function (f) { return f.properties.usecase === 'poi'; })
      }
    }
  }, [_vm._v("EXPORT")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 h-40"
  }, [_c('div', {
    staticClass: "btn btn-danger btn-xs",
    on: {
      "click": function($event) {
        _vm.geoWipe('pois')
      }
    }
  }, [_vm._v("WIPE")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2 bold"
  }, [_vm._v("Level Changers")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 h-40"
  }, [_vm._v(_vm._s(_vm.geodata.filter(function (f) { return f.properties.usecase === 'levelchanger'; }).length))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 h-40"
  }, [_c('div', {
    staticClass: "btn btn-xs",
    on: {
      "click": function($event) {
        _vm.exportGeoItems('levelchangers', function (f) { return f.properties.usecase === 'levelchanger'; })
      }
    }
  }, [_vm._v("EXPORT")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 h-40"
  }, [_c('div', {
    staticClass: "btn btn-danger btn-xs",
    on: {
      "click": function($event) {
        _vm.geoWipe('levelchangers')
      }
    }
  }, [_vm._v("WIPE")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2 bold"
  }, [_vm._v("Paths")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 h-40"
  }, [_vm._v(_vm._s(_vm.geodata.filter(function (f) { return f.properties.class === 'path'; }).length))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 h-40"
  }, [_c('div', {
    staticClass: "btn btn-xs",
    on: {
      "click": function($event) {
        _vm.exportGeoItems('paths', function (f) { return f.properties.class === 'path'; })
      }
    }
  }, [_vm._v("EXPORT")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 h-40"
  }, [_c('div', {
    staticClass: "btn btn-danger btn-xs",
    on: {
      "click": function($event) {
        _vm.geoWipe('paths')
      }
    }
  }, [_vm._v("WIPE")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2 bold"
  }, [_vm._v("Others")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 h-40"
  }, [_vm._v(_vm._s(_vm.geodata.filter(function (f) { return f.properties.class !== 'path' && f.properties.usecase !== 'poi' && f.properties.usecase !== 'levelchanger'; }).length))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 h-40"
  }, [_c('div', {
    staticClass: "btn btn-xs",
    on: {
      "click": function($event) {
        _vm.exportGeoItems('other', function (f) { return f.properties.class !== 'path' && f.properties.usecase !== 'poi' && f.properties.usecase !== 'levelchanger'; })
      }
    }
  }, [_vm._v("EXPORT")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 h-40"
  }, [_c('div', {
    staticClass: "btn btn-danger btn-xs",
    on: {
      "click": function($event) {
        _vm.geoWipe('other')
      }
    }
  }, [_vm._v("WIPE")])])])]), _vm._v(" "), (_vm.isAdmin()) ? _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "tab-data"
    }
  }, [_c('ul', {
    staticClass: "nav nav-tabs nav-tabs-simple nav-tabs-left no-padding no-margin"
  }, [_c('li', {
    staticClass: "active no-padding no-margin"
  }, [_c('a', {
    staticClass: "p-l-0",
    attrs: {
      "data-toggle": "tab",
      "href": "#tab-data-places"
    }
  }, [_vm._v("\n              Places "), _c('span', {
    class: {
      'bold': true,
      'text-success': _vm.data.places.length > 0,
        'text-warning': _vm.data.places.length === 0
    }
  }, [_vm._v(_vm._s(_vm.data.places.length))])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "p-l-0",
    attrs: {
      "data-toggle": "tab",
      "href": "#tab-data-floors"
    }
  }, [_vm._v("\n              Floors "), _c('span', {
    class: {
      'bold': true,
      'text-success': _vm.data.floors.length > 0,
        'text-warning': _vm.data.floors.length === 0
    }
  }, [_vm._v(_vm._s(_vm.data.floors.length))])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "p-l-0",
    attrs: {
      "data-toggle": "tab",
      "href": "#tab-data-departments"
    }
  }, [_vm._v("\n              Departments "), _c('span', {
    class: {
      'bold': true,
      'text-success': _vm.data.departments.length > 0,
        'text-warning': _vm.data.departments.length === 0
    }
  }, [_vm._v(_vm._s(_vm.data.departments.length))])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "p-l-0",
    attrs: {
      "data-toggle": "tab",
      "href": "#tab-data-geofences"
    }
  }, [_vm._v("\n              Geofences "), _c('span', {
    class: {
      'bold': true,
      'text-success': _vm.data.geofences.length > 0,
        'text-warning': _vm.data.geofences.length === 0
    }
  }, [_vm._v(_vm._s(_vm.data.geofences.length))])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "p-l-0",
    attrs: {
      "data-toggle": "tab",
      "href": "#tab-data-inputs"
    }
  }, [_vm._v("\n              Inputs "), _c('span', {
    class: {
      'bold': true,
      'text-success': _vm.data.inputs.length > 0,
        'text-warning': _vm.data.inputs.length === 0
    }
  }, [_vm._v(_vm._s(_vm.data.inputs.length))])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "p-l-0",
    attrs: {
      "data-toggle": "tab",
      "href": "#tab-data-applications"
    }
  }, [_vm._v("\n              Applications "), _c('span', {
    class: {
      'bold': true,
      'text-success': _vm.data.applications.length > 0,
        'text-warning': _vm.data.applications.length === 0
    }
  }, [_vm._v(_vm._s(_vm.data.applications.length))])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content p-t-0"
  }, [_c('div', {
    staticClass: "tab-pane slide-left active",
    attrs: {
      "id": "tab-data-places"
    }
  }, [_c('div', {
    staticClass: "row p-l-10 p-r-10"
  }, [_c('h2', {
    staticClass: "p-l-10"
  }, [_vm._v("Places")]), _vm._v(" "), _vm._l((_vm.data.places), function(place) {
    return _c('div', {
      key: place.id,
      staticClass: "place-box col-md-6"
    }, [_c('h4', [_vm._v(_vm._s(place.name))]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4 bold"
    }, [_vm._v("id")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8"
    }, [_vm._v(_vm._s(place.id))])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4 bold"
    }, [_vm._v("address")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8 h-40"
    }, [_vm._v(_vm._s(place.address))])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4 bold"
    }, [_vm._v("tags")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8"
    }, [(place.tags) ? _vm._t("default", [_vm._v("\n                      " + _vm._s(place.tags.join(", ")) + "\n                    ")]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4 bold"
    }, [_vm._v("latitude")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8"
    }, [(place.location) ? _vm._t("default", [_vm._v(_vm._s(place.location.lat))]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4 bold"
    }, [_vm._v("longitude")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8"
    }, [(place.location) ? _vm._t("default", [_vm._v(_vm._s(place.location.lng))]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4 bold"
    }, [_vm._v("raw data")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8"
    }, [_c('span', {
      staticClass: "pointer text-success bold",
      on: {
        "click": function($event) {
          _vm.$bus.$emit('raw', place)
        }
      }
    }, [_vm._v("show")])])])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane slide-left",
    attrs: {
      "id": "tab-data-floors"
    }
  }, [_c('div', {
    staticClass: "row p-l-10 p-r-10"
  }, [_c('h2', {
    staticClass: "p-l-10"
  }, [_vm._v("Floors")]), _vm._v(" "), _vm._l((_vm.data.floors), function(floor) {
    return _c('div', {
      key: floor.id,
      staticClass: "floor-box col-md-6"
    }, [_c('h4', [_vm._v(_vm._s(floor.name))]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4 bold"
    }, [_vm._v("id")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8"
    }, [_vm._v(_vm._s(floor.id))])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4 bold"
    }, [_vm._v("place")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8"
    }, [_vm._v(_vm._s(floor.place_name))])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4 bold"
    }, [_vm._v("level")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8"
    }, [_vm._v(_vm._s(floor.level))])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4 bold"
    }, [_vm._v("floorplan url")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8 break-word"
    }, [_vm._v(_vm._s(floor.floorplan_image_url))])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4 bold"
    }, [_vm._v("anchors")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8"
    }, _vm._l((floor.anchors), function(anchor, index) {
      return _c('div', {
        key: index,
        staticClass: "anchor"
      }, [_c('span', {
        staticClass: "small"
      }, [_vm._v(_vm._s(anchor.lat))]), _vm._v(" / "), _c('span', {
        staticClass: "small"
      }, [_vm._v(_vm._s(anchor.lng))])])
    }))]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4 bold"
    }, [_vm._v("raw data")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8"
    }, [_c('span', {
      staticClass: "pointer text-success bold",
      on: {
        "click": function($event) {
          _vm.$bus.$emit('raw', floor)
        }
      }
    }, [_vm._v("show")])])])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane slide-left",
    attrs: {
      "id": "tab-data-departments"
    }
  }, [_c('div', {
    staticClass: "row p-l-10 p-r-10"
  }, [_c('h2', {
    staticClass: "p-l-10"
  }, [_vm._v("Departments")]), _vm._v(" "), _vm._l((_vm.data.departments), function(department) {
    return _c('div', {
      key: department.id,
      staticClass: "departments-box col-md-6"
    }, [_c('h4', [_vm._v(_vm._s(department.name))]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4 bold"
    }, [_vm._v("id")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8"
    }, [_vm._v(_vm._s(department.id))])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4 bold"
    }, [_vm._v("place")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8"
    }, [_vm._v(_vm._s(department.place_name))])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4 bold"
    }, [_vm._v("floor")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8"
    }, [_vm._v(_vm._s(department.floor_name))])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4 bold"
    }, [_vm._v("geofences")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8"
    }, [_vm._v(_vm._s(_vm.data.geofences.filter(function (g) { return g.department_id === department.id; }).map(function (i) { return i.name; }).join(", ")))])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4 bold"
    }, [_vm._v("inputs")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8"
    }, [_vm._v(_vm._s(_vm.data.inputs.filter(function (i) { return i.department_id === department.id; }).map(function (i) { return i.name; }).join(", ")))])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4 bold"
    }, [_vm._v("raw data")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8"
    }, [_c('span', {
      staticClass: "pointer text-success bold",
      on: {
        "click": function($event) {
          _vm.$bus.$emit('raw', department)
        }
      }
    }, [_vm._v("show")])])])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane slide-left",
    attrs: {
      "id": "tab-data-geofences"
    }
  }, [_c('div', {
    staticClass: "row p-l-10 p-r-10"
  }, [_c('h2', {
    staticClass: "p-l-10"
  }, [_vm._v("Geofences")]), _vm._v(" "), _vm._l((_vm.data.geofences), function(geofence) {
    return _c('div', {
      key: geofence.id,
      staticClass: "geofences-box col-md-6"
    }, [_c('h4', [_vm._v(_vm._s(geofence.name))]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4 bold"
    }, [_vm._v("id")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8"
    }, [_vm._v(_vm._s(geofence.id))])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4 bold"
    }, [_vm._v("place")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8"
    }, [_vm._v(_vm._s(geofence.place_name))])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4 bold"
    }, [_vm._v("floor")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8"
    }, [_vm._v(_vm._s(geofence.floor_name))])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4 bold"
    }, [_vm._v("department")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8"
    }, [_vm._v(_vm._s(geofence.department_name))])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4 bold"
    }, [_vm._v("radius")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8"
    }, [_vm._v(_vm._s(geofence.radius) + "m")])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4 bold"
    }, [_vm._v("area")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8"
    }, [_c('span', {
      staticClass: "small"
    }, [_vm._v(_vm._s(geofence.area.lat))]), _vm._v(" / "), _c('span', {
      staticClass: "small"
    }, [_vm._v(_vm._s(geofence.area.lng))])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4 bold"
    }, [_vm._v("polygon")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8"
    }, [(geofence.polygon && typeof _vm.shownPolygons[geofence.id] === 'undefined') ? _c('span', {
      staticClass: "pointer text-success bold",
      on: {
        "click": function($event) {
          _vm.shownPolygons[geofence.id] = true;
          _vm.update()
        }
      }
    }, [_vm._v("show polygon")]) : _vm._e(), _vm._v(" "), (_vm.shownPolygons[geofence.id] === true) ? _vm._t("default", _vm._l((geofence.polygon), function(anchor, index) {
      return _c('div', {
        key: index,
        staticClass: "anchor"
      }, [_c('span', {
        staticClass: "small"
      }, [_vm._v(_vm._s(anchor[0]))]), _vm._v(" / "), _c('span', {
        staticClass: "small"
      }, [_vm._v(_vm._s(anchor[1]))])])
    })) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4 bold"
    }, [_vm._v("raw data")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8"
    }, [_c('span', {
      staticClass: "pointer text-success bold",
      on: {
        "click": function($event) {
          _vm.$bus.$emit('raw', geofence)
        }
      }
    }, [_vm._v("show")])])])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane slide-left",
    attrs: {
      "id": "tab-data-inputs"
    }
  }, [_c('div', {
    staticClass: "row p-l-10 p-r-10"
  }, [_c('h2', {
    staticClass: "p-l-10"
  }, [_vm._v("Inputs")]), _vm._v(" "), _vm._l((_vm._.sortBy(_vm.data.inputs, 'name')), function(input) {
    return _c('div', {
      key: input.id,
      class: {
        'geofences-box col-md-6': true,
        'input-ibeacon': input.type === 'iBeacon',
          'input-eddystone': input.type === 'Eddystone Beacon'
      }
    }, [_c('h4', [_vm._v(_vm._s(input.name))]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4 bold"
    }, [_vm._v("id")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8"
    }, [_vm._v(_vm._s(input.id))])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4 bold"
    }, [_vm._v("type")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8"
    }, [_vm._v(_vm._s(input.type))])]), _vm._v(" "), (input.type === 'Eddystone Beacon') ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4 bold"
    }, [_vm._v("namespace")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8"
    }, [_vm._v(_vm._s(input.data.namespace))])]) : _vm._e(), _vm._v(" "), (input.type === 'Eddystone Beacon') ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4 bold"
    }, [_vm._v("instance id")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8"
    }, [_vm._v(_vm._s(input.data.instanceId))])]) : _vm._e(), _vm._v(" "), (input.type === 'iBeacon') ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4 bold"
    }, [_vm._v("uuid")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8"
    }, [_vm._v(_vm._s(input.data.uuid))])]) : _vm._e(), _vm._v(" "), (input.type === 'iBeacon') ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4 bold"
    }, [_vm._v("major")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8"
    }, [_vm._v(_vm._s(input.data.major))])]) : _vm._e(), _vm._v(" "), (input.type === 'iBeacon') ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4 bold"
    }, [_vm._v("minor")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8"
    }, [_vm._v(_vm._s(input.data.minor))])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4 bold"
    }, [_vm._v("department")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8"
    }, [_vm._v(_vm._s(_vm.getDepartment(input.department_id).name))])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4 bold"
    }, [_vm._v("floor")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8"
    }, [_vm._v(_vm._s(_vm.getFloorByDepartment(input.department_id).name))])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4 bold"
    }, [_vm._v("marker")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8"
    }, [(input.data && input.data.marker) ? _vm._t("default", [_c('span', {
      staticClass: "small"
    }, [_vm._v(_vm._s(input.data.marker.lat))]), _vm._v(" / "), _c('span', {
      staticClass: "small"
    }, [_vm._v(_vm._s(input.data.marker.lng))])]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4 bold"
    }, [_vm._v("raw data")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8"
    }, [_c('span', {
      staticClass: "pointer text-success bold",
      on: {
        "click": function($event) {
          _vm.$bus.$emit('raw', input)
        }
      }
    }, [_vm._v("show")])])])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane slide-left",
    attrs: {
      "id": "tab-data-applications"
    }
  }, [_c('div', {
    staticClass: "row p-l-10 p-r-10"
  }, [_c('h2', {
    staticClass: "p-l-10"
  }, [_vm._v("Applications")]), _vm._v(" "), _vm._l((_vm._.sortBy(_vm.data.applications, 'name')), function(application) {
    return _c('div', {
      key: application.id,
      staticClass: "application-box col-md-6"
    }, [_c('h4', [_vm._v(_vm._s(application.name))]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4 bold"
    }, [_vm._v("id")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8"
    }, [_vm._v(_vm._s(application.id))])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4 bold"
    }, [_vm._v("ibeacons")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8"
    }, [_vm._v(_vm._s(application.settings.ibeacons))])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4 bold"
    }, [_vm._v("eddystones")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8"
    }, [_vm._v(_vm._s(application.settings.eddystones))])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4 bold"
    }, [_vm._v("native gps")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8"
    }, [_vm._v(_vm._s(application.settings.gpsgeofences))])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4 bold"
    }, [_vm._v("indooratlas")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8"
    }, [_vm._v(_vm._s(application.settings.indooratlas))])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4 bold"
    }, [_vm._v("steerpath")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8"
    }, [_vm._v(_vm._s(application.settings.steerpath))])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4 bold"
    }, [_vm._v("token")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8"
    }, [(typeof _vm.shownTokens[application.id] === 'undefined') ? _c('span', {
      staticClass: "pointer text-success bold",
      on: {
        "click": function($event) {
          _vm.shownTokens[application.id] = true;
          _vm.update()
        }
      }
    }, [_vm._v("show token")]) : _vm._e(), _vm._v(" "), (_vm.shownTokens[application.id] === true) ? _c('div', {
      staticClass: "token-wrapper"
    }, [_c('span', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.applicationTokens[application.id]))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4 bold"
    }, [_vm._v("raw data")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8"
    }, [_c('span', {
      staticClass: "pointer text-success bold",
      on: {
        "click": function($event) {
          _vm.$bus.$emit('raw', application)
        }
      }
    }, [_vm._v("show")])])])])
  })], 2)])])]) : _vm._e()])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn-link btn-disabled text-danger"
  }, [_c('i', {
    staticClass: "pg-home"
  }), _vm._v("BLOCK ACCOUNT")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": "#tab-overview"
    }
  }, [_vm._v("Overview")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": "#tab-geodata"
    }
  }, [_vm._v("Geo Data")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-left"
  }, [_c('p', {
    staticClass: "small no-margin"
  }, [_vm._v("Active plan")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-right"
  }, [_c('p', {
    staticClass: "small text-success bold cursor"
  }, [_vm._v("CHANGE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-left"
  }, [_c('p', {
    staticClass: "small no-margin"
  }, [_vm._v("Expires At")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3 col-md-3"
  }, [_c('h5', {
    staticClass: "bold no-margin p-t-5"
  }, [_vm._v("155")]), _vm._v(" "), _c('p', {
    staticClass: "small no-margin"
  }, [_vm._v("Unique Visitors")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "col-lg-6 no-margin"
  }, [_vm._v("Unique Visitors")]), _vm._v(" "), _c('td', {
    staticClass: "col-lg-6 no-margin"
  }, [_vm._v("155")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "col-lg-6 no-margin"
  }, [_vm._v("API Requests Today")]), _vm._v(" "), _c('td', {
    staticClass: "col-lg-6 no-margin"
  }, [_vm._v("752")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "col-lg-6 no-margin"
  }, [_vm._v("API Requests (7 days)")]), _vm._v(" "), _c('td', {
    staticClass: "col-lg-6 no-margin"
  }, [_vm._v("5401")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "col-lg-6 no-margin"
  }, [_vm._v("API Requests (30d)")]), _vm._v(" "), _c('td', {
    staticClass: "col-lg-6 no-margin"
  }, [_vm._v("25312")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "col-lg-6 no-margin"
  }, [_vm._v("Position Updates")]), _vm._v(" "), _c('td', {
    staticClass: "col-lg-6 no-margin"
  }, [_vm._v("52341")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "col-lg-6 no-margin"
  }, [_vm._v("Enter / Exit Events")]), _vm._v(" "), _c('td', {
    staticClass: "col-lg-6 no-margin"
  }, [_vm._v("1421")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b1907ab"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Organization.vue
// module id = 1377
// module chunks = 1